<template>
    <div>
        <div class="mx-n3 mb-3">
            <legend class="font-weight-semibold h5 px-3">
                <i class="fa-solid fa-key mr-2"></i> {{ $t("Verification Code") }}
            </legend>
        </div>
        <div class="form-group mb-2">
            <label class="mb-2">
                {{ $t('Step 2 : Please enter the 6-digit code we sent to:') }}
                <template v-if="$parent.verifyMethodId == 1">
                    <span class="px-1">{{$parent.userData.email}}</span>
                    ({{$t('Ref No.')}}: <span id="ref_code">{{ $parent.refCodeId }}</span>)
                    {{$t('To verify your email.')}}
                </template>
                <template v-if="$parent.verifyMethodId == 2">
                    <span class="px-1">+66 ··· ··· ··{{$parent.userData.mobile.substr($parent.userData.mobile.length - 2)}},</span>
                    ({{$t('Ref No.')}}: <span id="ref_code">{{ $parent.refCodeId }}</span>)
                    {{$t('To verify your phone number.')}}
                </template>
            </label>
            <div class="form-group form-group-feedback form-group-feedback-left">
                <input v-model="inputVerficationCode" maxlength="6" class="form-control" :placeholder="$t('Enter verification code...')">
                <div class="form-control-feedback">
                    <i v-if="$parent.verifyMethodId == 1" class="fa-regular fa-envelope"></i>
                    <i v-if="$parent.verifyMethodId == 2" class="fa-regular fa-comment-sms"></i>
                </div>
    
                <label class="validation-invalid-label" v-if="message">{{ $t(message) }}</label>
    
            </div>
        </div>
        <div>
            <span v-if="timeOut" @click="resetTimeLeft()" class="text-primary cursor-pointer">
                <i class="fa-regular fa-rotate-right mr-1"></i><u>{{$t('Resend code')}}</u>
            </span>
            <span v-else>
                <i class="fa-regular fa-rotate-right mr-1"></i>{{$t('Please resend code in')}} {{timeLeft}}
            </span>
        </div>
    
    </div>
    </template>
    
    <script>
    import bcrypt from "bcryptjs";
    import CentralApi from '@/services/endpoint/central.service'
    
    
    export default {
    
        name: "VerificationCode",
        components: {},
        data() {
            return {
                timeOut: false,
                minute: 1,
                sec: 0,
                inputVerficationCode : '',
                message : '',
    
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.setInterval(() => {
                    if (this.sec > 0) {
                        this.sec--;
                    } else if (this.sec == 0 && this.minute > 0) {
                        this.sec = 59;
                        this.minute--;
                    } else {
                        // Timer hits 0 do what you want to do here.
                        this.timeOut = true;
                    }
                }, 1000);
            })
        },
        computed: {
            timeLeft() {
                return this.minute + ':' + this.zeroPad(this.sec, 2);
    
            },
        },
        methods: {
            zeroPad(input, length) {
                return (Array(length + 1).join('0') + input).slice(-length);
            },
            resetTimeLeft() {
                this.$parent.showVerificationCodeForm()
                this.timeOut = false;
                this.minute = 1;
                this.sec = 0;
            },
            handleVerficationCode() {
                this.message = '';
                this.$parent.addLoading(true);
                if (!this.timeOut) {
                    let text_inputVerficationCode = this.inputVerficationCode;
                    let text_inputVerficationCode_length =
                        text_inputVerficationCode;
                    let first_inputVerficationCode =
                        text_inputVerficationCode.substr(0, 3);
                    let end_inputVerficationCode = text_inputVerficationCode.substr(
                        3,
                        text_inputVerficationCode_length
                    );
                    let full_inputVerficationCode =
                        first_inputVerficationCode +
                        "GoSaaS" +
                        end_inputVerficationCode;
                        
                    bcrypt
                        .compare(full_inputVerficationCode, this.$parent.verificationCode)
                        .then( async (res) => {
                        if (res === true) {
                            this.$parent.addLoading(true);
                            let deleted = await CentralApi.User.deleteAccount(this.$parent.userData.id);
                            if (deleted.data.status) {
                                this.$parent.closeModal();
                                this.$toastr.s(
                                    this.$t("Delete account success"),
                                    "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
                                );
                                this.$cookie.remove('centralToken', {
                                    domain: '.' + process.env.CENTRAL_API_ROOT
                                });
                                location.href = process.env.CENTRAL_APP_URL;
                            } else {
                                this.message = deleted.data.message;
                                this.$parent.addLoading(false);
                            }

                        } else {
                            this.message = 'Input verification code not match, Try again!';
                            this.$parent.addLoading(false);
                        }
                    });
                } else {
                    this.message = 'This verify code timed out!';
                    this.$parent.addLoading(false);
                }
                
            },
        },
    
    };
    </script>
    


// WEBPACK FOOTER //
// src/components/central/account/security/VerificationCode.vue